import React from 'react';
import '../../node_modules/grommet-css'

import Hero from 'grommet/components/Hero';
import Image from 'grommet/components/Image';
import Box from 'grommet/components/Box';
import Card from 'grommet/components/Card';

class HeroHeader extends React.Component {
    render() {
        return (
            <Box background={<Image src='/assets/back.jpg'
                                     fit='contain'
                                     full={true} />}
                  backgroundColorIndex='dark'>
                <Box direction='row'
                     justify='center'
                     align='center'>
                    <Box basis='1/2'
                         align='end'
                         pad='medium' />
                    <Box basis='1/2'
                         align='start'
                         pad='medium'>
                        <Box colorIndex='grey-2-a'>
                            <Card heading='Roy Watson'
                                  description='Experienced. Dependable. Innovative.'
                                  label='Software Development'
                            />
                        </Box>
                    </Box>
                </Box>
            </Box>
        );
    }
}

export default HeroHeader


// WEBPACK FOOTER //
// src/static/HeroHeader.js